import React from 'react'
import { Link } from 'react-router-dom';
const Blogcart = (props) => {
    const blog = props.blog;
    return (

        <div className="text-center shadow rounded-md overflow-hidden" data-aos={blog.animation}>
            <img className="h-52  w-80 mx-auto lg:w-full" src={blog.img} alt="" />
            <div className="p-2">
                <p className="text-ash text-sm text-center py-2">{blog.date} | 2 comments</p>
                <h1 className="font-bold text-xl"><Link className="hover:text-primary-txt" to={"/blogs/" + blog.id}>{blog.name}</Link></h1>
                <p className="flex items-center text-ash text-sm py-2 justify-center gap-2">in {blog.categories.map(pd => <p>{pd} </p>)}</p>
                <p className="text-ash text-sm">{blog.shortdes}..</p>
                <p className="text-primary-txt text-sm text-center py-2">
                    <Link className="hover:text-new" to={"/blogs/" + blog.id}>
                        Continue Reading...
                    </Link>
                </p>
            </div>

        </div>

    )
}

export default Blogcart
